import React from 'react'
import Crud from 'components/platform/Crud'
import { MODAL_NAME } from 'config/modals'
import { renderDate, printName } from 'components/platform/Table/renders'
import NewButton from 'components/platform/Search/NewButton'
import { FormattedMessage } from 'react-intl'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: true,
    width: 50,
  },
  {
    title: <FormattedMessage id={'global.order_number'} />,
    dataIndex: 'orderNumber',
    sorter: true,
    className: 'text-center',
    width: 140,
  },
  {
    title: <FormattedMessage id={'global.status'} />,
    dataIndex: 'orderStatus',
    sorter: true,
    width: 150,
    render: printName,
  },
  {
    title: <FormattedMessage id={'global.carrier_number'} />,
    dataIndex: 'carrierNumber',
    sorter: true,
    className: 'text-center',
    width: 150,
  },
  {
    title: <FormattedMessage id={'global.customer_no'} />,
    dataIndex: 'customerNo',
    sorter: true,
    className: 'text-center',
    width: 130,
  },
  {
    title: <FormattedMessage id={'global.purchase_order'} />,
    dataIndex: 'purchaseOrder',
    sorter: true,
    className: 'text-center',
    width: 160,
  },
  {
    title: <FormattedMessage id={'global.due_date'} />,
    dataIndex: 'dueDate',
    sorter: true,
    className: 'text-center',
    render: renderDate,
    width: 140,
  },
  {
    title: <FormattedMessage id={'global.order_date'} />,
    dataIndex: 'orderDate',
    sorter: true,
    className: 'text-center',
    render: renderDate,
    width: 140,
  },
  {
    title: <FormattedMessage id={'global.discount'} />,
    dataIndex: 'discount',
    sorter: true,
    className: 'text-center',
    width: 110,
  },
  {
    title: <FormattedMessage id={'global.paid'} />,
    dataIndex: 'paid',
    sorter: true,
    className: 'text-center',
    width: 110,
  },
  {
    title: <FormattedMessage id={'global.carrier'} />,
    dataIndex: 'orderCarrier',
    sorter: true,
    render: printName,
    width: 160,
  },
  {
    title: <FormattedMessage id={'global.deal'} />,
    dataIndex: 'deal',
    sorter: true,
    width: 210,
    render: printName,
  },
  {
    title: <FormattedMessage id={'global.currency'} />,
    dataIndex: 'currency',
    sorter: true,
    width: 150,
    render: printName,
  },
  {
    title: <FormattedMessage id={'global.tax'} />,
    dataIndex: 'tax',
    sorter: true,
    className: 'text-center',
    width: 80,
    render: printName,
  },
  {
    title: <FormattedMessage id={'global.created_at'} />,
    dataIndex: 'createdAt',
    sorter: true,
    className: 'text-center',
    render: renderDate,
    width: 110,
  },
  {
    title: <FormattedMessage id={'global.updated_at'} />,
    dataIndex: 'updatedAt',
    sorter: true,
    className: 'text-center',
    render: renderDate,
    width: 130,
  },
]

const OrdersField = ({ contact, account }) => (
  <Crud
    pageLayout={'inline'}
    pageTitle={'Admin Order'}
    renderSearch={({ modals, getTable }) => (
      <div style={{ fontSize: 20, padding: '10px 0' }} className={'clearfix'}>
        <FormattedMessage id={'global.orders'} />
        <div className={'pull-right'}>
          <NewButton
            title={<FormattedMessage id={'global.new_order'} />}
            onClick={() => {
              modals.open(MODAL_NAME.order, {
                itemId: 0,
                onClose: () => {
                  setTimeout(() => getTable().fetch(), 400)
                },
                // onRemoteSaved: (apiResponse) => form.setFieldValue(field.name,[...(field.value || []), apiResponse.data['@id']]),
                defaultItem: { contact, account },
              })
            }}
          />
        </div>
      </div>
    )}
    apiResource={'/api/orders'}
    modalKey={MODAL_NAME.order}
    filters={{ contact, account }}
    searchValues={{ filter: '' }}
    tableSorter={{ field: 'id', order: 'desc' }}
    tableColumns={columns}
  />
)

export default OrdersField
